import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEye = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 5.7c-4.09 0-7.585 2.613-9 6.3 1.415 3.688 4.91 6.3 9 6.3s7.584-2.612 9-6.3c-1.416-3.687-4.91-6.3-9-6.3Zm0 10.5c-2.258 0-4.09-1.881-4.09-4.2 0-2.318 1.832-4.2 4.09-4.2s4.09 1.882 4.09 4.2c0 2.319-1.832 4.2-4.09 4.2Zm0-6.72c-1.358 0-2.455 1.126-2.455 2.52 0 1.395 1.097 2.52 2.455 2.52s2.454-1.125 2.454-2.52c0-1.394-1.096-2.52-2.454-2.52Z"
    />
  </svg>
);
const Memo = memo(SvgIconEye);
export default Memo;
